import { useCallback, useEffect, useState } from 'react'
import usePolling from './usePolling'
import { subscriptionService } from '../services'

const useSubscriptionJobStatus = (
  jid,
  isActive = false,
  interval = 10000,
  initialDelay = 0,
  stopOn404 = true,
  jobAction = 'create_subscription',
) => {
  const [shouldPoll, setShouldPoll] = useState(isActive)

  const fetcher = useCallback(
    async () => {
      const result = await subscriptionService.jobStatus(jid, jobAction)
      return result
    },
    [jid, jobAction]
  )

  const shouldContinuePolling = (data) => {
    if (!data) return true

    const finalStatuses = [200, 409, 422, 503]

    if (stopOn404) {
      finalStatuses.push(404)
    }

    const hasError = data.status >= 500

    return !finalStatuses.includes(data.status) && !hasError
  }

  const { data, refresh, stopPolling } = usePolling(fetcher, {
    interval,
    enabled: shouldPoll,
    retryCount: 3,
    retryInterval: 10000,
    initialDelay
  })

  useEffect(() => {
    if (data && !shouldContinuePolling(data)) {
      setShouldPoll(false)
    }
  }, [data])

  useEffect(() => {
    setShouldPoll(isActive)
  }, [isActive])


  return {
    status: data?.status,
    error: data?.error,
    message: data?.message,
    isSuccess: data?.status === 200,
    isProcessing: data?.status === 202,
    isNotFound: data?.status === 404,
    isUnprocessableEntity: data?.status === 422,
    isRenewEnrollmentRequested: data?.status === 409,
    isFailed: data?.status === 503,
    hasError: data?.status >= 500 && data?.status !== 503,
    refresh,
    stopPolling,
    data,
  }
}

export default useSubscriptionJobStatus
